module.exports = __webpack_public_path__ + "img/DSC06537.82c63530.webp";